import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { updateCurrentPostRegisterPage } from "../../../../../../store/actions/admin/create-event";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import { getCurrentCustomPage } from "../../../../../../utils/admin-routing-utils";
import { ParamsProps } from "../../../../../live-event/live-event";
import PostRegisterEditorMain from "../../post-register-preview/post-register-editor-main";

const CustomPageEditor = React.forwardRef<HTMLDivElement>((props, ref) => {
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);

	const { customPath } = useParams() as ParamsProps;
	const dispatch = useDispatch();

	const currentCustomPage = useMemo(
		() => getCurrentCustomPage(workingEvent?.custom_pages, customPath),
		[workingEvent?.custom_pages, customPath]
	);

	useEffect(() => {
		// set currentPage as custom page path and reset it when the component is unmounted
		dispatch(updateCurrentPostRegisterPage(customPath));
		return () => {
			dispatch(updateCurrentPostRegisterPage(null));
		};
	}, [dispatch, customPath]);

	return (
		<PostRegisterEditorMain
			ref={ref}
			pageModuleList={currentCustomPage?.modules ?? []}
			isCustomPage={true}
			customPageId={currentCustomPage?.custom_page}
		/>
	);
});
CustomPageEditor.displayName = "Custom Page";
export default CustomPageEditor;
